require('styles/Form_layout.css');

import React from 'react';
import Reflux from 'reflux';
import FormItemContainer from './FormItemContainer';
import FormItemUtil from '../utils/FormItemUtil';
import {CmdUpdateControlLabelStore,CmdUpdateControlPropertyStore} from '../stores/CmdTypeStore';
import {GetSubFieldGroupMaxWidthStore,SetSubFieldGroupMaxWidthStore,GroupRefersheStore} from '../stores/ResizeStore';
import {UtilStore} from '../stores/UtilStores';
import FormItemConst from './FormItemConst';
require('../styles/FormItemFieldGroupStyle.css');

class FormItemFieldGroup extends FormItemContainer
{
	constructor(props) 
	{
		super(props);
		this.state.label = this.props.label;
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		this.unsubscribeCmdUpdateControlPropertyStore = CmdUpdateControlPropertyStore.listen(this.onCmdUpdateControlProperty.bind(this));
		this.unsubscribeGetSubFieldGroupMaxWidthStore = GetSubFieldGroupMaxWidthStore.listen(this.onGetSubFieldGroupMaxWidth.bind(this));
		this.unsubscribeSetSubFieldGroupMaxWidthStore = SetSubFieldGroupMaxWidthStore.listen(this.onSetSubFieldGroupMaxWidth.bind(this));
		this.unsubcribeUpdateControlLabelStore = UtilStore.listen(this.onUpdateControlLabel.bind(this));

		this.unsubscribeRefershSetStore = GroupRefersheStore.listen(this.componentRefresh.bind(this))
	}

	componentWillUnmount()
	{
		this.unsubscribeCmdUpdateControlLabelStore();
		this.unsubscribeCmdUpdateControlPropertyStore();
	}

	onGetSubFieldGroupMaxWidth(_id,maxWidths)
	{
		if(this.props.parentXMLId != _id)
			return;
		maxWidths.push(this.labelMaxWidth);
	}

	onSetSubFieldGroupMaxWidth(_id,maxWidth)
	{
		if(this.props.parentXMLId != _id)
			return;
		if(this.isSingleForm())
		{
			$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(
				function()
				{
					$(this).width(maxWidth);
				}
			);
			
			if(this.titleDiv)
			{
				let titleWidth = this.labelMaxWidth;
				let dv = maxWidth - titleWidth;
				
				$(this.leftLineDiv).width($(this.leftLineDiv).width() + dv);
				
			}
		}
		else
		{
			$(this.refs.fieldGroupMutiRowDom).find(".form-vertical").each(
				function()
				{
					$(this).find(".fieldGroupLabel").each(
						function()
						{
							$(this).width(maxWidth);
						}
					);	

				}
			);
		}
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.setState({label:_label});
		}
	}

	onUpdateControlLabel(arg)
	{
		if(arg.controlId == this.props.xml.id)
		{
			let maxWidth = 0;
			if(this.isSingleForm())
			{
				$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(
					function()
					{
						//alert($(this).width());
						$(this).width("auto");

						var thisWidth = $(this).width();
						if(thisWidth <= 0)
						{
							var _text = $(this).text();
							thisWidth = _text.visualLength();
						}
							
						if(thisWidth>maxWidth)
							maxWidth = thisWidth;
					}
				);

				if(this.titleDiv)
				{
					let titleWidth = $(this.titleDiv).outerWidth();
					maxWidth = Math.max(titleWidth+10,maxWidth);
				}

				//alert(maxWidth);
				$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(
					function()
					{
						$(this).width(maxWidth);
					}
				);

				if(this.titleDiv)
				{
					let titleWidth = $(this.titleDiv).outerWidth();
					let dv = maxWidth - titleWidth;
					if(dv>0)
					{
						$(this.leftLineDiv).width($(this.leftLineDiv).width() + dv);
					}
				}
			}
			else
			{
				$(this.refs.fieldGroupMutiRowDom).find(".form-vertical").each(
					function()
					{
						$(this).find(".fieldGroupLabel").each(
							function()
							{	
								$(this).width("auto")			
								
								var thisWidth = $(this).width();
								if(thisWidth <= 0)
								{
									var _text = $(this).text();
									thisWidth = _text.visualLength();
								}

								if(thisWidth>maxWidth)
									maxWidth = thisWidth;
							}
						);

						$(this).find(".fieldGroupLabel").each(
							function()
							{
								$(this).width(maxWidth);
							}
						);	

					}
				);
			}

			this.labelMaxWidth = maxWidth;
		}
	}

	onCmdUpdateControlProperty(name,property,value,moduleInstanceId)
	{
		if(name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(property == ControlPropertyConst.HASBORDER)
		{
			if(value)
			{
				$(this.containerComponent).css({border:"solid 1px #ccc",margin:"1px"});
			}
			else
			{
				$(this.containerComponent).css({border:"none",margin:"1px"});
			}
		}
	}

	getStyle()
	{
		let parentLayout = this.props.parentLayout;
		let style = {
		 	//width:'auto'
	    };
	    if(parentLayout == "horizontal")
	    {
	    	//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
	    	//alert(json);
	    	let _width = this.props.xml.Properties.Width.Value;
	    	if(_width == undefined)
	    		_width = "";
			let flexGrow = 0;
			let fixedWidth = false;
			let iex = _width.indexOf("%");
			if(iex!=-1)
			{
				flexGrow = _width.substring(0,iex);
			}
			
			if(iex==-1&&_width != "")
			{
				style['width'] = _width+"px";
				fixedWidth = true;
			}	
			
			if(!fixedWidth)style["flexGrow"] = flexGrow; 

			let _height = this.props.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.props.xml.Properties.Height.Value;
	    	if(_height==undefined)
	    		_height = "";
			let flexGrow = 0;
			let fixedHeight = false;
			let iex = _height.indexOf("%");
			if(iex!=-1)
			{
				flexGrow = _height.substring(0,iex);
			}
			if(iex==-1&&_height != "")
			{
				//flexGrow = _height+"px";
				style['height'] = _height+"px";
				fixedHeight = true;
			}	
			
			if(!fixedHeight)style["flexGrow"] = flexGrow; 

			let _width = this.props.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
	    }
		
		return style;
	}

	componentRefresh(arrg){
		if( arrg && arrg.formId == this.props.formId &&  this.props.xml.id == arrg.innerId){
			this.setState({});
			// this.updateAllLabelWidth(false);
		}
		
	}

	componentDidMount()
	{
		super.componentDidMount();
		//$(document).ready(this.test.bind(this));
		//$(this.refs.boxdom).css("min-width",($(this.refs.boxdom).width()+10)+"px");
		this.updateAllLabelWidth();
	}

	componentDidUpdate() {
		//TODO_YL 切换tabpage或控制显隐性的 时候 重新计算 宽度 单 title 宽度 不在做增加
		this.updateAllLabelWidth(false);
	}

	updateAllLabelWidth(titleWidthAdd=true)
	{
		let maxWidth = 0;
		if(this.isSingleForm())
		{
			$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(
				function()
				{
					//alert($(this).width());
					var thisWidth = $(this).width();
					if(thisWidth <= 0)
					{
						var _text = $(this).text();
						thisWidth = _text.visualLength();
					}
						 
					if(thisWidth>maxWidth)
						maxWidth = thisWidth;
				}
			);
			if(titleWidthAdd){
				if(this.titleDiv)
				{
					let titleWidth = $(this.titleDiv).outerWidth();
					maxWidth = Math.max(titleWidth+10,maxWidth);
				}
			}

			//alert(maxWidth);
			$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(
				function()
				{
					$(this).width(maxWidth);
				}
			);
			if(titleWidthAdd){
				if(this.titleDiv)
				{
					let titleWidth = $(this.titleDiv).outerWidth();
					let dv = maxWidth - titleWidth;
					if(dv>0)
					{
						$(this.leftLineDiv).width($(this.leftLineDiv).width() + dv);
					}
				}
			}
		}
		else
		{
			$(this.refs.fieldGroupMutiRowDom).find(".form-vertical").each(
				function()
				{
					$(this).find(".fieldGroupLabel").each(
						function()
						{							
							if($(this).width()>maxWidth)
								maxWidth = $(this).width();
						}
					);

					$(this).find(".fieldGroupLabel").each(
						function()
						{
							$(this).width(maxWidth);
						}
					);	

				}
			);
		}

		this.labelMaxWidth = maxWidth;	
	}

	isSingleForm()
	{
		let children = this.props.xml.FormItem;
		if(!children)
			return true;
		var childLength = children.length;
		if(childLength<2)
			return true;
		var count = this.props.columns;
		var layout = this.props.layout;//this.props.parentLayout;
		if(layout == "vertical" && count == 1)
			return true;
		return false;
	}

	getSingleFormChildren()
	{
		let parent = this.props.xml;
		let children = parent.FormItem;
		let list = [];
		let that = this;
		if(children)
		{
			list = children.map(function(item){
				return FormItemUtil.getFormItemInstance(that.props.menuItemId,that.props.formId,item,parent,that.props.forLookup);
			});
		}
		return list;
	}

	getMutiRowColChildren()
	{
		var _layout = this.props.layout;
		let children = this.props.control.childrenControl;
		let length = children.length;
		if(_layout == "vertical" || (_layout == "horizontal" && this.props.columns == 1))
		{
			var count = this.props.columns;
			//var _form:GongqiFormBox = new GongqiFormBox();
			var flatChildren = [];
			var columnChildren = [];
			var _num = 0;
			var _visnum=0;
			for(let _i = 0;_i<length;_i++)
			{
				var child = children[_i];
				if(_num<count)
				{
					let uiChild = child.getComponentInstance(this.props.xml,this.props.forLookup);
					//TODO_YL 
					if(!uiChild.props.controlVisible && uiChild.props.hideInVisible){
						count++;
						_visnum++;
					};
					columnChildren.push(uiChild);
					_num++;
					if(_i == length-1)
					{
						flatChildren.push(columnChildren);
						//(control as Container).addElement(_form);
					}
				}
				else
				{
					count = this.props.columns;
					_visnum = 0;
					_num = 0;
					_i--;
					//(control as Container).addElement(_form);
					flatChildren.push(columnChildren);
					columnChildren = [];
				}
			}
			let resultArr = [];
			for(let i = 0;i<flatChildren.length;i++)
			{
				let itemArray = flatChildren[i];
				resultArr.push(
					<div key={i} style={{display:"flex",flexDirection:"column",alignItems:"stretch"}} className="form-vertical">
						{itemArray}
					</div>
				);
			}
			return resultArr;
		}
		else
		{
			var count = this.props.columns;
			var rowNum = length/count;
			var remainder = length%count;
			if(remainder>0)
				rowNum++;
			
			_num = 0;
			var arr = [];
			var _visnum = 0;
			for(let _i = 0; _i<count; _i++)
			{
				var subarr = [];
				arr.push(subarr);
			}
			for(let _i = 0; _i<length; _i++)
			{
				child = children[_i];
				if(_num < count)
				{
					let uiChild = child.getComponentInstance(this.props.xml,this.props.forLookup);
					arr[_num].push(uiChild);
					if(!uiChild.props.controlVisible && uiChild.props.hideInVisible){
						_visnum++;
						_num--;
					};
					_num++;
				}
				else
				{
					count = this.props.columns;
					_visnum = 0;
					_num = 0;
					_i--;
				}
			}
			let resultArr = [];
			for(let i = 0;i<arr.length;i++)
			{
				let subarr = arr[i];
				resultArr.push(<div key={i} style={{display:"flex",flexDirection:"column",alignItems:"stretch"}} className="form-vertical">
									{subarr}
								</div>
				);			
			}
			return resultArr;
		}
		
	}

	
	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		if(!_style)_style = {};
		_style.paddingLeft = '7px';
		if(!_style.hasOwnProperty('width')){_style.width='auto';}
		_style.marginBottom = '2px';
		
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
		
		let list;let component;
		let _id = this.props.xml.name?this.props.xml.name:this.props.xml.id;
		if(this.isSingleForm())
		{
			list = this.getSingleFormChildren();
			component = <form className="form-vertical" ref="fieldGroupdom">
							{list}
		 				</form>;
		}
		else
		{
			list = this.getMutiRowColChildren();
			component = <div style={{display:"flex",flexDirection:"row",alignItems:"stretch"}} className='form-wrap fieldGroupMutiRow' ref="fieldGroupMutiRowDom">
							{list}
						</div>
		}

		let showLabel=this.props.showLabel;
		
		if(showLabel && this.state.label){

			//let _titleAlign = this.props.titleAlign;
			let _titleStyle = {fontSize:"15px",paddingLeft:'5px',paddingRight:'5px'};
			let _titleBoxStyle = {marginBottom:'9px',display:'flex',flexDirection:'row',alignItems:'center'};
			/*if(_titleAlign == "Left")
			{
				_titleStyle.paddingLeft = "10px";_titleStyle.borderLeft = "3px solid #555";_titleBoxStyle.textAlign = "left";
			}
			else if(_titleAlign == "Center")
			{
				_titleBoxStyle.textAlign = "center";
			}
			else
			{
				_titleStyle.paddingRight = "10px";_titleStyle.borderRight = "3px solid #555";_titleBoxStyle.textAlign = "right";
			}*/
			return (
				<div id={_id} className="FormItemFieldGroup FormItemFieldGroupWidthTitle box box-info" style={_style} ref={node => this.containerComponent = node} ref="boxdom">
		            <div className="box-header with-border" style={_titleBoxStyle}>
					  <div ref={node=>this.leftLineDiv=node} style={{height:'1px',backgroundColor:'#D8D8D8',width:'10px'}}></div>
		              <h4 ref={node=>this.titleDiv=node} className="box-title" style={_titleStyle}>{this.state.label}</h4>
					  <div style={{height:'1px',backgroundColor:'#D8D8D8',flexGrow:'1'}}></div>
		            </div>
				    {component}
	          	</div>
			);
		}else{
			_style.borderTop='0px';
			return (
				<div id={_id} className="FormItemFieldGroup box box-info" style={_style} ref={node => this.containerComponent = node} ref="boxdom">
				    {component}
	          	</div>
			);
		}


	
		
	}
};

FormItemFieldGroup.defaultProps = {
};

export default FormItemFieldGroup;



// WEBPACK FOOTER //
// ./src/formItem/FormItemFieldGroup.js